import { ChangeDetectorRef, Component } from "@angular/core";
import { isUser, User, userToString } from "src/services/user/user.interface";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { UserApiService } from "src/services/user/user-api.service";
import { from, Observable } from "rxjs";
import { BaseSearchFormFieldComponent } from "../base-search-form-field.component";

@Component({
  selector: "rc-user-form-field",
  templateUrl: "../base-search-form-field.component.html",
  styleUrls: ["../base-search-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: UserFormFieldComponent,
    },
  ],
  standalone: false,
})
export class UserFormFieldComponent extends BaseSearchFormFieldComponent<User> {
  constructor(
    private readonly userService: UserApiService,
    cdr: ChangeDetectorRef,
  ) {
    super(cdr);
  }

  public toDisplayString(input: User): string {
    return userToString(input);
  }

  protected getById(id: string): Observable<User> {
    return from(this.userService.getById(id));
  }

  protected getNoValueString(): string {
    return "No user selected";
  }

  protected search(input: string): Observable<User[]> {
    return from(this.userService.search(input));
  }

  public readonly isUser = isUser;
}
